"use client";

import { useEffect } from "react";
import { captureException } from "@/lib/sentry";
import { useTranslation } from "@/lib/i18n";

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  const { t } = useTranslation();

  useEffect(() => {
    captureException(error);
  }, [error]);

  return (
    <div className="min-h-screen flex items-center justify-center p-6">
      <div className="max-w-md text-center space-y-6">
        <div className="text-xs font-mono uppercase tracking-widest text-mint-text">
          {t("error.label")}
        </div>
        <h1 className="text-2xl font-heading font-bold text-text-primary">
          {t("error.title")}
        </h1>
        <p className="text-text-muted text-sm">
          {t("error.description")}
        </p>
        <button
          onClick={reset}
          className="px-6 py-3 bg-mint text-black font-bold text-xs uppercase tracking-widest hover:bg-mint-hover transition-all"
        >
          {t("error.retry")}
        </button>
      </div>
    </div>
  );
}
